import { createFileRoute } from "@tanstack/react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { api } from "../../../lib/api";

export const Route = createFileRoute("/_authed/settings/logs")({
  component: LogsPage,
});

const inputStyle: React.CSSProperties = {
  padding: "8px 12px", background: "var(--surface-input)", border: "1px solid var(--line)",
  borderRadius: 8, color: "var(--ink)", fontSize: 13, outline: "none",
  width: "100%", boxSizing: "border-box",
};

const labelStyle: React.CSSProperties = {
  fontSize: 12, color: "var(--ink-secondary)", display: "block", marginBottom: 6,
};

function LogsPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery<{ max_executions_per_agent: number; max_days: number }>({
    queryKey: ["retention"],
    queryFn: () => api.get("/system/retention"),
  });

  const [form, setForm] = useState({ max_executions_per_agent: 10000, max_days: 90 });

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  const mut = useMutation({
    mutationFn: () => api.patch("/system/retention", form),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["retention"] }),
  });

  if (isLoading) {
    return <div style={{ color: "var(--ink-muted)", fontSize: 13 }}>Carregando...</div>;
  }

  return (
    <div style={{ maxWidth: 480, display: "flex", flexDirection: "column", gap: 20 }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>Retenção de Logs</div>
        <div style={{ fontSize: 13, color: "var(--ink-muted)" }}>
          As linhas antigas são removidas pelo limite que <strong style={{ color: "var(--ink-secondary)" }}>atingir primeiro</strong>.
          A limpeza roda automaticamente todos os dias às 03:00 UTC.
        </div>
      </div>

      <div style={{ background: "var(--surface-hover)", border: "1px solid var(--line)", borderRadius: 8, padding: 20, display: "flex", flexDirection: "column", gap: 16 }}>
        <div>
          <label style={labelStyle}>Máximo de execuções por agente</label>
          <input
            type="number"
            min={100}
            style={inputStyle}
            value={form.max_executions_per_agent}
            onChange={(e) => setForm({ ...form, max_executions_per_agent: parseInt(e.target.value, 10) || 100 })}
          />
          <div style={{ fontSize: 11, color: "var(--ink-muted)", marginTop: 4 }}>
            Mínimo: 100. As execuções mais antigas são removidas primeiro.
          </div>
        </div>

        <div>
          <label style={labelStyle}>Máximo de dias de retenção</label>
          <input
            type="number"
            min={7}
            max={3650}
            style={inputStyle}
            value={form.max_days}
            onChange={(e) => setForm({ ...form, max_days: parseInt(e.target.value, 10) || 7 })}
          />
          <div style={{ fontSize: 11, color: "var(--ink-muted)", marginTop: 4 }}>
            Entre 7 e 3650 dias. Execuções mais antigas que este limite são removidas.
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10, paddingTop: 4 }}>
          {mut.isSuccess && (
            <span style={{ fontSize: 12, color: "var(--ok)" }}>Salvo.</span>
          )}
          {mut.isError && (
            <span style={{ fontSize: 12, color: "var(--danger)" }}>Erro ao salvar.</span>
          )}
          <button
            onClick={() => mut.mutate()}
            disabled={mut.isPending}
            style={{
              background: "var(--brand)", color: "#fff", padding: "7px 16px",
              borderRadius: 8, fontSize: 13, fontWeight: 500, border: "none",
              cursor: mut.isPending ? "not-allowed" : "pointer",
              opacity: mut.isPending ? 0.7 : 1,
            }}
          >
            {mut.isPending ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
